import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-fe/sails_core';

import { createStructuredSelector } from 'reselect';

import { RootState } from './types';

import {
    setDefaultState,
} from './actions';

import { renderAndOpenOverlay } from '../../components/overlay';

import { sendWebchatMessage } from '../SendMessage/actions';

import { disconnect } from '../SessionDisconnect/actions';

import { getWebchat } from '../InitWebchat/actions';

import { refresh } from '../Refresh/actions';

import { selectWebchatAvailable } from './selector';

import './style.scss';

import {
    TRACKING,
} from 'Constant';

import {
    BOTNAME,
    HEADLINE,
    IMGICONSRC,
    INTENT_KEY_PARAM,
    MARKET_KEY_PARAM,
    NAMESPACE, OPEN, OPEN_KEY_PARAM, PATH, SUBLINE, TOPIC, WEBCHAT_START_ANCHOR,
} from './constants';

import {
    ID_WEBCHAT_HEADER,
} from './constants';

import uiWebchatReducer from './reducer';

import mountChatInputPanel from '../../components/chatInputPanel';

import trackingSaga from 'Container/Tracking/sagas';
import { mountIconTextComponent } from '../../components/iconText';

/**
 * Import containers
 */
import InitWebchat from '../InitWebchat';
import SendMessage from '../SendMessage';
import DisconnectWebchat from '../SessionDisconnect';
import RefreshWebchat from '../Refresh';

import { mountLoadingAnimation } from '../../components/loadingAnimation';
import { IUserData } from './interface';

function initWebchatUi (_state, actions) {

    InitWebchat();
    SendMessage();
    DisconnectWebchat();
    RefreshWebchat();

    injectReducer(NAMESPACE, uiWebchatReducer);
    injectSaga(TRACKING, trackingSaga);

    // make it public
    globalThis.webchatApi = (webchatConfig) => {

        actions.setDefaultState({
            webchatPath: webchatConfig.path,
            botName: webchatConfig.botName,
            topic: webchatConfig.topic,
            userData: webchatConfig.userData ? webchatConfig.userData : getUserData(getParams()),
        });
        // start webchat
        actions.getWebchat();
        actions.refresh();

        renderAndOpenOverlay(actions.disconnect);

        // mount chat header
        mountIconTextComponent (
            document.getElementById(ID_WEBCHAT_HEADER) as HTMLElement,
            `<h3> ${webchatConfig.headline}</h3> <span>${webchatConfig.subline}</span>`,
            webchatConfig.imgIconSrc,
        );

        // mount chat input panel and create always a new instance if chat started and disable first
        const chatInputPanel = mountChatInputPanel(actions.sendWebchatMessage, true);
        chatInputPanel.disableChatInput();

        mountLoadingAnimation().show();

    };

    startWebchatViaUrl();

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState
         */
        getDerivedStateFromProps (newState, oldState) {
            if (newState.webchatAvailable && (newState.webchatAvailable !== oldState.webchatAvailable)) {
                mountLoadingAnimation().hide();
            }
        },
    };
}
/**
 * Create a function
 *
 * @export {function} startWebchatViaUrl
 */
export function startWebchatViaUrl () {
    const params = getParams();
    const webchatAnchors = document.getElementsByClassName(WEBCHAT_START_ANCHOR);
    if (params?.open === OPEN && webchatAnchors?.length > 0) {
         globalThis.webchatApi({
             path: `${webchatAnchors[0]?.getAttribute(PATH)}`,
             topic: `${webchatAnchors[0]?.getAttribute(TOPIC)}`,
             botName: `${webchatAnchors[0]?.getAttribute(BOTNAME)}`,
             headline: HEADLINE,
             subline: SUBLINE,
             imgIconSrc: IMGICONSRC,
             userData: getUserData(params),
         });
    }
}
/**
 * Create a getParams function
 *
 * @export {function} getParams
 * @returns {object} return params object
 */
function getParams () {
    const urlString = location.href;
    const url = new URL(urlString);
    const params = {
        open: url.searchParams.get(OPEN_KEY_PARAM),
        market: url.searchParams.get(MARKET_KEY_PARAM),
        intent: url.searchParams.get(INTENT_KEY_PARAM),
    };

    return params;

}
/**
 * Create a getUserData function
 *
 * @export {function} getUserData
 * @returns {object} return userData object of type IUserData
 */
export function getUserData (params): IUserData {
     const userData: IUserData = {market: params?.market, intent: params?.intent};

    return userData;
}

/**
 * mapStateToProps = We are mapping the given states to props mapDispatch
 */
const mapStateToProps = createStructuredSelector<RootState, {}>({
    webchatAvailable: selectWebchatAvailable(),
});

/**
 * mapDispatch = We are mapping the given action dispatch function to props Result.
 * You can use the states and dispatches as a prop in the main function
 */
const mapDispatch = {
    getWebchat,
    refresh,
    sendWebchatMessage,
    disconnect,
    setDefaultState,
};

const InitWebchatUi = connect(mapStateToProps, mapDispatch)(initWebchatUi);

export default InitWebchatUi;
